import React from 'react';
import { Loading } from '@guildeducationinc/recess';

export const LoadingOverlay: React.FC = () => {
	return (
		<div className='flex align-items-center' style={{ height: '100vh' }}>
			<Loading label='loading page content' overlay={true} />
		</div>
	);
};
